import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const AutomationIcon = (props?: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <g clipPath="url(#clip0_15689_2520)">
      <path
        d="M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20Z"
        fill="white"
        fillRule="evenodd"
        opacity="0.99904"
      />
      <path
        d="M6.64918 9.86417L8.29166 10.2723L7.34599 14.0947C7.12699 14.9906 7.56499 15.2893 8.32152 14.7617L13.4779 11.1881C14.105 10.7501 14.0154 10.2425 13.2688 10.0533L11.6264 9.64512L12.5721 5.82263C12.791 4.92673 12.353 4.6281 11.5966 5.15569L6.44013 8.72932C5.81301 9.16731 5.90259 9.67503 6.64918 9.86417Z"
        fill="#00A0FF"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_15689_2520">
        <rect height="20" width="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
